import Badge from "@/src/components/atom/Badge";
import { PaymentStatusType } from "@/src/store/apis/subscription/interface";
import { TFunction } from "i18next";

const renderCreditPaymentStatusBadge = (param: {
  t: TFunction;
  type: PaymentStatusType | null;
  size?: "S" | "L";
}) => {
  const { t, type, size = "S" } = param;

  switch (type) {
    case "PAYMENT_SUCCESS":
      return (
        <Badge
          text={t("common:paymentComplete")}
          color="gray4"
          badgeColor="gray10"
          badgeSize={size}
        />
      );
    case "PAYMENT_FAIL":
      return (
        <Badge
          text={t("common:paymentFailed")}
          color="red2"
          badgeColor="red8"
          badgeSize={size}
        />
      );
    case "CANCEL_SUCCESS":
      return (
        <Badge
          text={t("common:paymentCancel")}
          color="gray7"
          badgeColor="gray10"
          badgeSize={size}
        />
      );
    case "REFUND_REQUIRE":
      return (
        <Badge
          text={t("common:refundSubmission")}
          color="gray7"
          badgeColor="gray10"
          badgeSize={size}
        />
      );
    case "REFUND_SUCCESS":
      return (
        <Badge
          text={t("common:paymentRefund")}
          color="gray7"
          badgeColor="gray10"
          badgeSize={size}
        />
      );
  }
};

export default renderCreditPaymentStatusBadge;
